module.exports = __webpack_public_path__ + "static/media/become_a_member.1fbd1282.jpg";